/**
 * Shop story — mission & vision, next to Kenny at the chair.
 *
 * Client revision (Sep 2026): the origin paragraph gave way to the client's
 * own mission/vision copy. The emphasised segments are placeholders —
 * {shopName} (uppercased by CSS to match the client's caps) and the {city}
 * community — so the facts still come from config.
 *
 * Sits on `page` cream rather than `paper` so it separates from the hero
 * above and the WhyKD block below, both of which are `paper`. The palette has
 * no `paper-warm`; these two creams are the whole warm range.
 *
 * Every number in the body is a placeholder. "Four years later" and "four
 * barbers alongside him" both go stale on a hire or a birthday, which is the
 * drift COPY_STYLE exists to stop.
 */

import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';

export default function ShopStory() {
  const c = useCopy().home.shopStory;
  const { t } = useShopConfig();

  return (
    <section className="bg-page px-6 py-16 md:px-12 md:py-24">
      {/* Grid, not flex-col-reverse: DOM order is already image-then-text,
          which is what mobile wants and what the desktop columns want. */}
      <div className="mx-auto grid max-w-6xl gap-10 md:grid-cols-2 md:items-center md:gap-16">
        <img
          src="/assets/atmospheric/kenny-at-work.jpg"
          alt={t(c.imageAlt)}
          width={1091}
          height={1600}
          className="aspect-[4/5] w-full rounded-card object-cover shadow-[0_24px_60px_rgba(11,27,58,0.12)] md:min-h-[560px]"
        />

        <div className="flex max-w-[540px] flex-col gap-6">
          <h2 className="font-newsreader text-[34px] font-medium leading-[1.1] text-navy md:text-[46px]">
            {t(c.mission.heading)}
          </h2>
          <p className="font-newsreader text-[19px] leading-[1.65] text-slate-body md:text-[20px]">
            {t(c.mission.lead)}
            <strong className="font-semibold uppercase text-navy">{t(c.mission.emph)}</strong>
            {t(c.mission.tail)}
          </p>
          <h2 className="mt-4 font-newsreader text-[34px] font-medium leading-[1.1] text-navy md:text-[46px]">
            {t(c.vision.heading)}
          </h2>
          <p className="font-newsreader text-[19px] leading-[1.65] text-slate-body md:text-[20px]">
            {t(c.vision.p1)}
            <strong className="font-semibold text-navy">{t(c.vision.emph1)}</strong>
            {t(c.vision.p2)}
            <strong className="font-semibold uppercase text-navy">{t(c.vision.emph2)}</strong>
            {t(c.vision.p3)}
          </p>
        </div>
      </div>
    </section>
  );
}
